import React from "react";

export const PodcastCcButton = ({ enabled, onToggle }) => (
  <button
    type="button"
    onClick={onToggle}
    aria-label={enabled ? "Turn captions off" : "Turn captions on"}
    aria-pressed={enabled}
    title={enabled ? "Turn captions off" : "Turn captions on"}
    style={{
      background: enabled ? "#0877dc" : "rgba(255,255,255,.95)",
      color: enabled ? "#fff" : "#111827",
      border: enabled ? "2px solid #fff" : "2px solid transparent",
      padding: "16px 20px",
      borderRadius: 14,
      cursor: "pointer",
      fontWeight: 900,
      fontSize: 18,
      boxShadow: "0 12px 28px rgba(0,0,0,.35)"
    }}
  >
    CC
  </button>
);

export const PodcastCaptionOverlay = ({ text, isMobile }) => {
  if (!text) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        width: "min(760px, 92vw)",
        minHeight: 58,
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px 18px",
        borderRadius: 12,
        background: "rgba(8, 15, 28, 0.72)",
        backdropFilter: "blur(4px)",
        color: "#fff",
        fontSize: isMobile ? 17 : 19,
        lineHeight: 1.35,
        fontWeight: 700,
        textAlign: "center",
        boxShadow: "0 8px 24px rgba(0,0,0,.3)"
      }}
    >
      {text}
    </div>
  );
};
